module.exports = __webpack_public_path__ + "assets/images/2-USED.bf2774e9.svg";